import React from "react";
import "./App.css";
import NavbarCustom from "./Layout/NavbarCustom";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import TableForm from "./TableForm";
import logoPng from "../src/Img/logo.png";
import { Card } from "react-bootstrap";
import Menu from "./Layout/Menu";
import LoginForm from "./Login";
import RegistrationForm from "./Registration";

import useLocalStorage from "./Utility/useLocalStorage"






function App() {
  const [localStorage, setLocalStorage] = useLocalStorage("LoginUser");



  return (
    <Router>
      <div
        className="container-fluid "
        style={{ background: "#f2f7fc", minHeight: "100%" }}
      >
        <div className="row">
          <div className="col-12">
            <NavbarCustom></NavbarCustom>
          </div>
          <div className="col-2">
            <div className="row pl-5">
              <img src={logoPng}></img>
            </div>

            <Menu></Menu>
          </div>

          <div className="col-10">
            <div className="row col-12">
              <h1>Stato Civile</h1>
              <h6>
                Questo tool ti permette di gestire le domande all’interno del
                chatbot. Puoi visualizzare le domande già presenti, modificarle
                eliminarle o eventualmente inserirne di nuove.
              </h6>
            </div>

            <Routes>

              {!localStorage ? <>
                <Route path="/login" element={<LoginForm />}></Route>
                <Route
                  exact
                  path="/register"
                  element={<RegistrationForm></RegistrationForm>}
                ></Route>
                <Route path="/" element={<LoginForm />}></Route></>
                :
                <Route
                  path="/"
                  element={<TableForm projectId="dl-anusca-stato-civile-qjr9" />}
                ></Route>
              }

            </Routes>
          </div>
        </div>
      </div>
    </Router >
  );
}

export default App;
